import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useMemo,
  useCallback,
  memo,
} from "react";

type NodeDataContextType = {
  nodeData: any;
  selectedNodeId: string;
  getNodeData: (nodeId: string, data: any) => void;
};

const NodeDataContext = createContext<NodeDataContextType | undefined>(
  undefined
);

export const useNodeDataContext = (): NodeDataContextType => {
  const context = useContext(NodeDataContext);
  return context as NodeDataContextType;
};

const NodeDataProvider = ({ children }: { children: ReactNode }) => {
  const [nodeData, setNodeData] = useState<any>("");
  const [selectedNodeId, setSelectedNodeId] = useState<string>("");

  const getNodeData = useCallback((nodeId: string, data: any) => {
    setSelectedNodeId(nodeId);
    setNodeData(data);
  }, []);

  const contextValue = useMemo(
    () => ({
      nodeData,
      selectedNodeId,
      getNodeData,
    }),
    [nodeData, selectedNodeId, getNodeData]
  );

  return (
    <NodeDataContext.Provider value={contextValue}>
      {children}
    </NodeDataContext.Provider>
  );
};

export default memo(NodeDataProvider);
